import jsCookie from 'js-cookie';
import { ACTIONS, COOKIES, ERRORTYPES, ENVIRONMENT } from '../constants';
import getEnvVariable from '../utils/environment';
import { setCookieWithDomain } from '../utils/cookieHelpers';

// eslint-disable-next-line
export const postRecaptcha = recaptchaResponse => (dispatch) => {
  if (recaptchaResponse === undefined) {
    return {
      type: ACTIONS.POST_RECAPTCHA,
      captcha_isValid: false,
      captcha_errorType: ERRORTYPES.CAPTCHA_INVALID,
    };
  }
  const makoAPIURL = `${getEnvVariable(ENVIRONMENT.MAKO_URL)}/v3/public/s2s/signup/recaptcha_verify`;
  return fetch(makoAPIURL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ recaptcha: recaptchaResponse }),
  }).then((response) => {
    if (response.ok) {
      response.json().then((json) => {
        setCookieWithDomain(COOKIES.SIGNUP_SESSION, json.signup_session_token);
        dispatch({
          type: ACTIONS.POST_RECAPTCHA,
          captcha_isValid: true,
          captcha_errorType: ERRORTYPES.NO_TYPE_SET,
          signup_session_token: json.signup_session_token,
        });
      });
    } else {
      jsCookie.remove(COOKIES.SIGNUP_SESSION);
      dispatch({
        type: ACTIONS.POST_RECAPTCHA,
        captcha_isValid: false,
        captcha_errorType: ERRORTYPES.NO_TYPE_SET,
        signup_session_token: '',
      });
    }
  }).catch((error) => {
    console.log(error);
    dispatch({
      type: ACTIONS.POST_RECAPTCHA,
      captcha_isValid: false,
      captcha_errorType: ERRORTYPES.CAPTCHA_INVALID,
      signup_session_token: '',
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/captcha.js